webpackJsonp([9,18],{

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _appConfig = __webpack_require__(2);

var videoList = function videoList() {
	var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _appConfig.ARTICLE_NUMBER_PER_PAGE;
	return fetch(_appConfig.apiUri + '/video?from=' + from + '&take=' + count).then(function (res) {
		return res.json();
	}).catch(function (err) {
		return console.error(err);
	});
};

exports.default = videoList;

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(18);

__webpack_require__(21);

__webpack_require__(22);

__webpack_require__(8);

__webpack_require__(54);

__webpack_require__(43);

__webpack_require__(25);

__webpack_require__(56);

__webpack_require__(143);

var _toggleModal = __webpack_require__(49);

var _toggleModal2 = _interopRequireDefault(_toggleModal);

__webpack_require__(15);

var _setupCommonJS = __webpack_require__(16);

var _setupCommonJS2 = _interopRequireDefault(_setupCommonJS);

var _appConfig = __webpack_require__(2);

var _languageBasedTag = __webpack_require__(24);

var _languageBasedTag2 = _interopRequireDefault(_languageBasedTag);

var _videoList = __webpack_require__(109);

var _videoList2 = _interopRequireDefault(_videoList);

var _generateVideoCard = __webpack_require__(204);

var _generateVideoCard2 = _interopRequireDefault(_generateVideoCard);

var _itemStartFrom = __webpack_require__(61);

var _itemStartFrom2 = _interopRequireDefault(_itemStartFrom);

var _pagination = __webpack_require__(62);

var _hideLoadingImage = __webpack_require__(14);

var _hideLoadingImage2 = _interopRequireDefault(_hideLoadingImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _setupCommonJS2.default)();

document.head.appendChild((0, _languageBasedTag2.default)());

(0, _jquery2.default)('body').on('click', '.modal-marker', function (e) {
	return (0, _toggleModal2.default)(e.target);
});

(0, _videoList2.default)((0, _itemStartFrom2.default)(_pagination.currentPage, _appConfig.ARTICLE_NUMBER_PER_PAGE)).then(function (json) {
	json.videos.forEach(function (item) {
		document.querySelector('.section-block > .content').appendChild((0, _generateVideoCard2.default)(item.title, '', _appConfig.uploadUri + '/' + item.thumb, item.youtube_id));
	});
	(0, _pagination.addPaginationButtons)(json.total, _appConfig.ARTICLE_NUMBER_PER_PAGE);
}).then(function () {
	(0, _hideLoadingImage2.default)();
}).catch(function (err) {
	return console.error(err);
});

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _generateBasicCardBlock = __webpack_require__(44);

var _generateBasicCardBlock2 = _interopRequireDefault(_generateBasicCardBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateVideoCard = function generateVideoCard(title, date, imageUrl, videoId) {
	var template = (0, _generateBasicCardBlock2.default)(title, date, imageUrl);

	template.classList.add('modal-marker');
	template.setAttribute('data-target', 'youtube-video');

	template.addEventListener('click', function () {
		document.querySelector('.youtube-video').innerHTML = '<iframe frameborder="0"\n\t\tallowfullscreen="1" \n\t\twidth="100%" \n\t\theight="100%" \n\t\tsrc="https://www.youtube.com/embed/' + videoId + '?enablejsapi=1&amp;controls=1&amp;autohide=1&amp;\n\t\tautoplay=1&amp;showinfo=1&amp;rel=0&amp;theme=dark&amp;wmode=opaque"></iframe>';
	});

	return template;
};

exports.default = generateVideoCard;

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlParser = __webpack_require__(9);

var _urlParser2 = _interopRequireDefault(_urlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * this function return a base tag which is base on language path
 *
 * You don't have to add the base tag in every page,
 * just use in the page url which has two or more path after the language, like: `/tw/about/video`.
 * If you are at `/tw/about`, you don't have to add this base tag.
 */
var LanguageBasedTag = function LanguageBasedTag() {
  var baseTag = document.createElement('base');
  baseTag.setAttribute('href', '/' + _urlParser2.default.language + '/');

  return baseTag;
};

exports.default = LanguageBasedTag;

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var generateBasicCardBlock = function generateBasicCardBlock(title, date, imageUrl) {
	var template = document.querySelector('._template-block > .card-block').cloneNode(true);

	template.lastChild.lastChild.innerText = title;
	template.lastChild.firstChild.innerText = date;
	template.firstChild.setAttribute('style', 'background-image: url(' + imageUrl + ')');

	return template;
};

exports.default = generateBasicCardBlock;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(4);
__webpack_require__(5);
module.exports = __webpack_require__(201);


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * prevent page scrolling when focusing inputs inside the modal
 */
var lockBodyScrolling = function lockBodyScrolling() {
	document.body.style.top = document.body.scrollTop * -1 + 'px';
	document.body.classList.add('-locked');
};

/**
 * unlock
 */
var unlockBodyScrolling = function unlockBodyScrolling() {
	document.body.classList.remove('-locked');
	document.body.scrollTop = parseInt(document.body.style.top, 10) * -1;
	document.body.style.top = 'auto';
};

/**
 * find the flag element in order to get the dataset infomation
 */
var findMarker = function findMarker(element) {
	if (element.classList.contains('modal-marker')) {
		return element;
	}

	var target = element.parentNode;
	while (!target.classList.contains('modal-marker')) {
		target = target.parentNode;
	}

	return target;
};

var toggleModal = function toggleModal(target) {
	var $modal = (0, _jquery2.default)('.modal-block');
	var targetElement = findMarker(target);

	(0, _jquery2.default)('.' + targetElement.dataset.target).toggleClass('-hide');

	if ($modal.hasClass('-show')) {
		$modal.removeClass('-visible');
		setTimeout(function () {
			return $modal.removeClass('-show');
		}, 500);
		$modal.find('.closebtn').off('click');

		/**
   * unlock body
   */
		unlockBodyScrolling();

		return;
	}

	$modal.addClass('-show -visible');
	$modal.find('.closebtn').on('click', function () {
		toggleModal(targetElement);
		if (!(0, _jquery2.default)('.youtube-video').is(':empty')) {
			(0, _jquery2.default)('.youtube-video').html('');
		}
	});

	/**
  * lock body
  */
	lockBodyScrolling();
};

exports.default = toggleModal;

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * tell you what the index number of the first data on this page is
 */
var itemStartFrom = function itemStartFrom(currentPage, numberInPage) {
	if (typeof currentPage !== 'number' || typeof numberInPage !== 'number') {
		return false;
	}

	if (currentPage === 1) {
		return 0;
	}

	return (currentPage - 1) * numberInPage;
};

exports.default = itemStartFrom;

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var currentPage = exports.currentPage = window.location.search ? parseInt(window.location.search.split('=')[1], 10) : 1;

var addPaginationButtons = exports.addPaginationButtons = function addPaginationButtons(total, numberInPage) {
	if (total > numberInPage) {
		for (var i = 1; i < total / numberInPage + 1; i += 1) {
			var template = document.querySelector('._template-block > .page').cloneNode(true);
			template.href += '?page=' + i;
			template.innerHTML = i;
			template.className += '' + (i === currentPage ? ' -active' : '');
			document.querySelector('.tab-list').appendChild(template);
		}
	}
};

exports.default = 'this is pagination';

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[479]);


// WEBPACK FOOTER //
// videos.0c7d9f7ace4fd.js